<script lang="ts">
    import type {Labeled} from 'src/typings';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';

    export let option: Labeled;
</script>

{pipe(option, loc())}